import { Col, Games, Highlights, PostsGrid, Row } from 'components';
import { updateGames } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SuggestedAccounts, Updates } from './components';

let timer;
const Home = (props) => {
  const [posts, setPosts] = useState([]);
  const homeData = useSelector((state) => state.home);
  const { isMobile } = useSelector((state) => state.appState);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { trendingAthletes, inspiringFans, games, updates } = homeData;

  /**
   * FOR ONLY TEXT POSTS!
   * Should wait for actual designs, hide the data for now
   */
  useEffect(() => {
    if (!homeData.posts) {
      return;
    }

    const filtered = homeData.posts.filter((x) => {
      if (!x.metaData && !x.youtubeId && !(x.media[0] && x.media[0].uri)) {
        return false;
      }

      return true;
    });

    setPosts(filtered);
  }, [homeData.posts]);

  useEffect(() => {
    updateGames('home');
    timer = setInterval(() => updateGames('home'), 30000);

    return () => clearInterval(timer);
  }, []);

  function handleSeeAll() {
    navigate('/posts/home', {
      state: { storeId: 'home', title: t('home.latestPosts') }
    });
  }

  return (
    <Col wid="100%" centerAll pad={isMobile ? '16px 0 119px 0' : '40px 0 119px 0'}>
      <Row noFlex wid={isMobile ? '100vw' : '936px'} pad={isMobile && '0 0 84px'} start>
        <Col gap={isMobile ? '16px' : '40px'}>
          <Highlights type="athlete" />

          <Updates data={updates} />

          <Games data={games} marg="0" />

          <Highlights type="fan" />

          <PostsGrid
            showFour
            marg="0"
            title={t('home.latestPosts')}
            data={posts}
            onSeeAll={handleSeeAll}
          />

          <SuggestedAccounts
            data={[...(trendingAthletes || []), ...(inspiringFans || [])]}
            marg="0"
          />
        </Col>
      </Row>
    </Col>
  );
};

export default Home;
